import * as React from 'react';
import { RefinementsContext } from '../RefinementsContext';
import {
  refinementsChangedDeep$,
  clearAll$,
  facetFilter$,
  priceSort$,
  numericFilter$,
  toggleFilter$,
} from './refinementsEvents';

export const useRefinementsEvents = () => {
  const { refinements } = React.useContext(RefinementsContext);
  const refinementsRef = React.useRef(JSON.stringify(refinements));
  React.useEffect(() => {
    const nextRefinementsString = JSON.stringify(refinements);
    if (nextRefinementsString !== refinementsRef.current) {
      refinementsRef.current = nextRefinementsString;
      // If we don't do setTimeout here, some listeners with `useEffect` can be
      // caught in the moment when they already unsubscribed, but did not subscribe again yet
      setTimeout(() => refinementsChangedDeep$.next(refinements), 0);
    }
  }, [refinements]);

  return {
    clearAll$,
    priceSort$,
    refinementsChangedDeep$,
    facetFilter$,
    numericFilter$,
    toggleFilter$,
  };
};
